let currentSlideIndex = 0
let nextSlideIndex = 0

const MOBILE_WIDTH = 500

const getElementProps = (element, keys) => {
  elementStyles = getComputedStyle(element)
  return keys.reduce(
    (props, key) => {
      if (key in elementStyles) {
        props[key] = elementStyles[key]
        return props
      }
    },
    {
      /* initialValue */
    } // пустой объект для сбора пар
  )
}

const moveContainer = offset => {
  return [
    { transform: `translateX(-${currentSlideIndex * offset}px)` },
    { transform: `translateX(-${nextSlideIndex * offset}px)` }
  ]
}
// let slidesContainerWidth = parseInt(
//   getElementProps(
//     document.querySelector('#home-main-slider #carousel-container'),
//     ['width']
//   ).width
// )

const loadCarousel = () => {
  document.querySelectorAll('#carousel').forEach(e => {
    //сколько слайдов генерировать на 1 прокрутку
    let defaultCount = e.getAttribute('data-default-count') || 1
    let tabletCount = e.getAttribute('data-tablet-count') || 1
    let mobileCount = e.getAttribute('data-mobile-count') || 1
    let currentCount = defaultCount

    if (window.innerWidth < TABLET_WIDTH) {
      currentCount = tabletCount
    } else if (window.innerWidth < MOBILE_WIDTH) {
      currentCount = mobileCount
    }

    let slidesArr = document.querySelector('#carousel-slides').children
    let slidesContainer = e.querySelector('#carousel-container')

    if (slidesContainer) {
      let bulletsContainer = e.querySelector('#carousel-bullets')

      // Создаём кнопки-навигацию
      const createBullet = index => {
        let bulletButton = document.createElement('button')
        bulletButton.classList.add('carousel-button')
        bulletButton.setAttribute('onclick', `bulletSlider(${index})`)
        bulletButton.textContent = index + 1 < 10 ? `0${index + 1}` : index + 1
        if (index == currentSlideIndex) bulletButton.classList.add('active')

        bulletsContainer.appendChild(bulletButton)
      }

      // Function to create slides
      const createSlide = (slide, index) => {
        const newSlide = slide.cloneNode(true)
        newSlide.classList.add('carousel-slide')
        newSlide.style.gridTemplateColumns = `repeat(${currentCount},1fr)`
        if (index == currentSlideIndex) newSlide.classList.add('active')
        // Add slide to container
        slidesContainer.appendChild(newSlide)
      }

      // Initialize Carousel
      const initialize = (arr, count) => {
        let newSlidesCount = Math.ceil(arr.length / count)
        // console.log('Количество слайдов: ', newSlidesCount)
        // console.log('Всего карточек: ', arr.length)
        // console.log(arr)
        for (let i = 0; i < newSlidesCount; i++) {
          createBullet(i)
          if (count != 1) {
            let newSlide = document.createElement('div')
            for (let k = 0; k < count; k++) {
              arr[i * count + k] &&
                newSlide.appendChild(arr[i * count + k].cloneNode(true))
            }
            createSlide(newSlide, i)
          } else {
            createSlide(arr[i], i)
          }
        }
      }
      initialize(slidesArr, currentCount)
      // Eventlistener

      window.addEventListener(
        'resize',
        debounce(() => {
          if (
            window.innerWidth > TABLET_WIDTH &&
            currentCount != defaultCount
          ) {
            let allSlides = e.querySelectorAll('.carousel-slide')
            allSlides.forEach(el => el.remove())
            let allBullets = e.querySelectorAll('#carousel-bullets button')
            allBullets.forEach(el => el.remove())
            currentCount = defaultCount
            console.log('default')
            initialize(slidesArr, currentCount)
          } else if (
            window.innerWidth < TABLET_WIDTH &&
            window.innerWidth > MOBILE_WIDTH &&
            currentCount != tabletCount
          ) {
            let allSlides = e.querySelectorAll('.carousel-slide')
            allSlides.forEach(el => el.remove())
            let allBullets = e.querySelectorAll('#carousel-bullets button')
            allBullets.forEach(el => el.remove())
            currentCount = tabletCount
            console.log('tablet')
            initialize(slidesArr, currentCount)
          } else if (
            window.innerWidth < MOBILE_WIDTH &&
            currentCount != mobileCount
          ) {
            let allSlides = e.querySelectorAll('.carousel-slide')
            allSlides.forEach(el => el.remove())
            let allBullets = e.querySelectorAll('#carousel-bullets button')
            allBullets.forEach(el => el.remove())
            currentCount = mobileCount
            console.log('mobile')
            initialize(slidesArr, currentCount)
          }
        }, 300)
      )
    }
  })
}
// Тестовый Контент для Слайдов

let bulletSlider = index => {
  let bullets = document.querySelectorAll('.carousel-button')
  let slides = document.querySelectorAll('.carousel-slide')
  currentSlideIndex = index
  for (let i = 0; i < slides.length; i++) {
    if (index == i) {
      bullets[i].classList.add('active')
      slides[i].classList.add('active')
    } else {
      bullets[i].classList.remove('active')
      slides[i].classList.remove('active')
    }
  }
}

let changeSlide = toSlide => {
  let bullets = document.querySelectorAll('.carousel-button')
  let slides = document.querySelectorAll('.carousel-slide')

  //убираем класс активного слайда у текущего
  slides[currentSlideIndex].classList.remove('active')
  bullets[currentSlideIndex].classList.remove('active')
  // вычисляем индекс следующего планируемого слайда
  nextSlideIndex = currentSlideIndex + toSlide
  if (nextSlideIndex > slides.length - 1) {
    nextSlideIndex = 0
  } else if (nextSlideIndex < 0) {
    nextSlideIndex = slides.length - 1
  }

  //применяем активный класс на следующем желаемом слайде
  slides[nextSlideIndex].classList.add('active')
  bullets[nextSlideIndex].classList.add('active')

  let slideWidth = parseInt(
    getElementProps(slides[nextSlideIndex], ['width']).width
  )

  // slides[nextSlideIndex].animate(moveContainer(slideWidth), 1000)
  // slides[currentSlideIndex].animate(moveContainer(slideWidth), 1000)
  // document
  //   .querySelector('#home-main-slider #carousel-container')
  //   .animate(moveContainer(slideWidth), 1000)

  // for (let i = 0; i < slides.length; i++) {
  //   if (slides[i].classList.contains('active')) {
  //     let endOfArray = currentSlideIndex > slides.length - 1 ? true : false
  //     let beginningOfArray = i + toSlide < 0 ? true : false

  //     if (endOfArray) {
  //       slides[0].classList.add('active')
  //       bullets[0].classList.add('active')
  //     } else if (beginningOfArray) {
  //       bullets[slides.length - 1].classList.add('active')
  //       slides[slides.length - 1].classList.add('active')
  //     } else {
  //       bullets[i + toSlide].classList.add('active')
  //       slides[i + toSlide].classList.add('active')
  //     }
  //     break
  //   }
  // }
  currentSlideIndex = nextSlideIndex
  nextSlideIndex = currentSlideIndex + 1
}

// Debounce
function debounce(func, time) {
  var time = time || 100 // 100 by default if no param
  var timer
  return function (event) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(func, time, event)
  }
}

document.addEventListener('DOMContentLoaded', loadCarousel)
